module.exports = __webpack_public_path__ + "media/thumbnails/head-style-3-6d761c88.svg";